import { Code, TrimmedCode } from "types/entities/Code";

import React from "react";
import { isCodeMatch, MatchSource } from "helpers/codeMatching";

import { TaxonomyItemCodeBox } from "components/codeComponents/TaxonomyItemCodeBox";

// matchSource: the selected rows' source codes and description text; matching boxes (helpers/codeMatching) are green
export const CodeBoxesList = React.memo<{ codes: (Code | TrimmedCode)[]; matchSource?: MatchSource }>(({
  codes,
  matchSource,
}) => {
  const sortedCodes = codes.sort((a, b) => {
    const typeCompare = a.type.localeCompare(b.type);
    return typeCompare === 0 ? a.code.localeCompare(b.code) : typeCompare;
  });

  if (sortedCodes.length === 0) return null;

  return (
    <div className="flex gap-2 flex-wrap">
      {sortedCodes.map(({ type, code }) => (
        <div key={`${type}-${code}`} className="max-w-full">
          <TaxonomyItemCodeBox
            type={type}
            code={code}
            isMatch={!!matchSource && isCodeMatch({ type, code }, matchSource)}
          />
        </div>
      ))}
    </div>
  );
});
